module.exports = __webpack_public_path__ + "img/fsn.807c57ac.svg";